
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/house-prices",
      function () {
        return require("private-next-pages/house-prices/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/house-prices"])
      });
    }
  